import React from "react";
import { Input } from "antd";
import { SearchIcon } from "icons/Icons";
import { IColumnData, IFilterValues, ProfessionalFilterColumnsProps } from "domain/order";

const RoamingItemsFilterColumns = ({
  columns,
  searchValues,
  handleFilterChange,
}: any) => {
  return columns.map((column: any) => {
    const columnIndex = column?.dataIndex || column?.key;
    if (!columnIndex || !column.title) return column;

    return {
      ...column,
      filterDropdownVisible: false,
      title: (
        <div>
          {column.title}
            <Input
              placeholder={`Search ${column.title}`}
              style={{
                width: "100%",
                marginBottom: 8,
                paddingRight: "6px",
                display: "block",
                marginTop: "10px",
              }}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              value={searchValues[columnIndex as keyof IFilterValues] || ""}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                e.preventDefault();
                e.stopPropagation();
                handleFilterChange(e, columnIndex as string);
              }}
            />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchIcon fill={filtered ? "#1890ff" : undefined} />
      ),
    };
  });
};

export default RoamingItemsFilterColumns;